import _ from 'lodash';

class BindedObject {
  constructor(...objectToBind) {
    _.forEach(objectToBind, o => this._bindFields(o));
  }

  _bindFields(object) {
    _.forEach(object, (val, key) => {
      this[key] = val;
    });
  }
}

export default BindedObject;
